<template>
    <div class="card ecard-template-block mb-0" :class="{ open: open }">
        <div class="card-header header-elements-inline bg-light justify-content-start">
            <div
                v-if="mode !== 'simple'"
                class="btn-float btn-handle fake-button mr-3"
                :class="{ 'handle': !locked }"
            >
                <i class="icon-arrow-resize8"></i>
            </div>
            <h6 class="card-title">{{ type }}</h6>
            <div v-if="mode !== 'simple'" class="header-elements ml-auto">
                <button type="button" class="btn btn-light btn-float rounded-pill custom-button ml-2" @click="toggleCollapsible"><i :class="collapsible_icon"></i></button>
                <div class="btn-group justify-content-center">
                    <a href="#" class="btn btn-light btn-float rounded-pill custom-button ml-2" data-toggle="dropdown"><i class="icon-menu"></i></a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a href="#" class="dropdown-item" :class="{ 'disabled': !!(locked) }" @click.prevent="deleteBlock">Delete</a>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="open || mode === 'simple'">
            <div class="card-body">
                <slot></slot>
            </div>
            <div class="card-footer" v-if="mode === 'advanced'">
                <div class="d-flex" style="gap: 16px;">
                    <div style="line-height: 36px;">Låst position:</div>
                    <div class="btn-group">
                        <button type="button" class="btn btn-light btn-sm" :class="{'active' : locked !== 'start' && locked !== 'end'}" @click="$emit('update:locked', null)">Nej</button>
                        <button type="button" class="btn btn-light btn-sm" :class="{'active' : locked === 'start'}" @click="$emit('update:locked', 'start')">Start</button>
                        <button type="button" class="btn btn-light btn-sm" :class="{'active' : locked === 'end'}" @click="$emit('update:locked', 'end')">End</button>
                    </div>
                    <input type="number" class="form-control" placeholder="Position" style="width: 80px;" :value="position" @input="$emit('update:position', $event.target.value)">
                </div>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name: 'TemplateBlock',
    props: {
        type: {
            required: true,
        },
        mode: {
            type: String,
            default: 'normal',
        },
        open: {
            type: Boolean,
            default: false,
        },
        locked: {
            type: [String, Number, Boolean],
            default: null,
        },
        position: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        toggleCollapsible() {
            this.$emit('toggle-collapsible');
        },
        deleteBlock() {
            this.$emit('delete');
        },
    },
    computed: {
        collapsible_icon() {
            if (this.open) {
                return 'icon-menu-close';
            }
            return 'icon-menu-open';
        },
    },
};
</script>
